import { render, staticRenderFns } from "./ColorPickerAndField.vue?vue&type=template&id=a1fba48e&scoped=true&"
import script from "./ColorPickerAndField.vue?vue&type=script&lang=js&"
export * from "./ColorPickerAndField.vue?vue&type=script&lang=js&"
import style0 from "./ColorPickerAndField.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ColorPickerAndField.vue?vue&type=style&index=1&id=a1fba48e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1fba48e",
  null
  
)

export default component.exports